export default __webpack_public_path__ + "static/media/Back_Btn.0cff99b2.svg";